import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth, startGoogleLogin } from '@/lib/AuthContext';
import { Button } from '@/components/ui/button';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
export const AuthCallback = () => {
  const location = useLocation(), navigate = useNavigate();
  const { completeGoogle } = useAuth(); const processed = useRef(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (processed.current) return; processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    const startedAt=Number(sessionStorage.getItem('google-login-started-at'));
    sessionStorage.removeItem('google-login-started-at');
    if(!sessionId||!startedAt||Date.now()-startedAt>15*60*1000||startedAt>Date.now()) {
      setError('Inicia el acceso con Google desde esta pestaña. El enlace no corresponde a un inicio reciente.');
      return;
    }
    completeGoogle(sessionId).then((user) => {
      const saved = sessionStorage.getItem('google-return-path'); sessionStorage.removeItem('google-return-path');
      const safe = saved?.startsWith('/') && !saved.startsWith('//') && !saved.includes('\\') && !saved.includes('#') && !saved.startsWith('/login');
      navigate(user.registration_restricted ? '/registro-vendedor' : user.platform_role === 'SUPER_ADMIN' ? '/platform' : safe ? saved : user.has_seller_access ? '/seller' : '/mi-cuenta', { replace: true });
    }).catch((e) => { setError(e.response?.data?.detail || 'No se pudo iniciar sesión con Google. Intenta nuevamente.'); });
  }, [completeGoogle, location.hash, navigate]);
  if (!error) return null;
  return <main className="min-h-screen flex items-center justify-center bg-background p-4"><Alert className="max-w-md bg-card" data-testid="auth-callback-error"><AlertTitle>No pudimos validar tu acceso</AlertTitle><AlertDescription><p className="my-4">{error}</p><div className="flex gap-3"><Button data-testid="auth-callback-retry" onClick={startGoogleLogin}>Reintentar con Google</Button><Button variant="outline" asChild data-testid="auth-callback-back"><Link to="/login" replace>Volver</Link></Button></div></AlertDescription></Alert></main>;
};
